import { SocialType } from "shared/SocialsShare/SocialsShare";
import React, { FC } from "react";

export interface SocialsListProps {
  className?: string;
  itemClass?: string;
  socials?: SocialType[];
  sharer?: string;
}

// fb sharer url
// https://www.facebook.com/sharer/sharer.php?u=https://redlinecars.co.uk/vehicle/audi-rs6-avant-4-0-tfsi-v8-performance-avant-tiptronic-quattro-ss-5dr-pan-roof-2020-20-reg-2/

const socialsDemo: SocialType[] = [
  {
    name: "Facebook", icon: "fab fa-facebook-f", href: "https://www.facebook.com/redlinespecialistcars",
    sharerPrefix: "https://www.facebook.com/sharer/sharer.php?u="
  },
  {
    name: "Twitter", icon: "fab fa-twitter", href: "https://twitter.com/redlinecarsuk",
    sharerPrefix: "https://twitter.com/intent/tweet?url="
  },
  {
    name: "Youtube", icon: "fab fa-youtube", href: "https://www.youtube.com/channel/UCRuGbePpiwIARqpuEa8bxng",
    sharerPrefix: "https://www.youtube.com/channel/UCRuGbePpiwIARqpuEa8bxng"
  },
  {
    name: "Instagram", icon: "fab fa-instagram", href: "https://www.instagram.com/redlinespecialistcars/",
    sharerPrefix: "https://www.instagram.com/redlinespecialistcars/"
  },
];

const SocialsList: FC<SocialsListProps> = ({
  className = "",
  itemClass = "block",
  socials = socialsDemo,
  sharer = "",
}) => {
  return (
    <nav
      className={`nc-SocialsList flex space-x-2.5 text-dark dark:text-white ${className}`}
      data-nc-id="SocialsList"
    >
      {socials.map((item, i) => (
        <a
          key={i}
          className={`${itemClass} `}
          href={
            sharer ? `${item.sharerPrefix}${sharer}` : item.href
          }
          target="_blank"
          rel="noopener noreferrer"
          title={item.name}
          aria-label={item.name}
        >
          <i className={`${item.icon} text-base ml-0.5`}></i>
        </a>
      ))}
    </nav>
  );
};

export default SocialsList;

